import { useParams } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { H1, Body } from '@/components/base/Typography';
import { PatientFormContent } from '@/components/forms/PatientFormContent';
/**
 * PatientFormPage Component
 *
 * Form for creating new patients or editing existing ones.
 *
 * Features:
 * - Create mode (no patientId param)
 * - Edit mode (with patientId param)
 * - React Hook Form with Zod validation
 * - Required and optional fields
 * - Loading states
 * - Error handling
 * - Success notifications
 * - Auto-redirect after save
 *
 * @accessibility
 * - All form fields properly labeled
 * - Required field indicators
 * - Error messages announced to screen readers
 * - Keyboard navigation support
 */
export function PatientFormPage() {
  const { patientId } = useParams<{ patientId?: string }>();

  return (
    <AppLayout>
      <div className="py-6">
        <div className="mx-auto max-w-4xl space-y-6">
          {/* Page Header */}
          {!patientId && (
            <div>
              <H1 className="!font-serif !text-xl !font-semibold text-pranik-brand">
                Add New Patient
              </H1>
              <Body className="mt-1 text-muted-foreground">
                Enter patient details to register a new patient.
              </Body>
            </div>
          )}

          <PatientFormContent patientId={patientId} />
        </div>
      </div>
    </AppLayout>
  );
}
